module.exports = __webpack_public_path__ + "img/background.e361de67.png";